import {
  Children,
  cloneElement,
  FC,
  isValidElement,
  MouseEvent,
  ReactElement,
  useState
} from 'react'

import { Menu } from '@mui/material'

import { MenuButton } from '../MenuButton'

type DropdownMenuProps = {
  label: string
  testId?: string
  variant?: 'contained' | 'outlined' | 'text'
  children?: ReactElement<{ onClick?: () => void }> | ReactElement<{ onClick?: () => void }>[]
}

export const DropdownMenu: FC<DropdownMenuProps> = ({
  label,
  children,
  testId,
  variant = 'outlined'
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }
  const handleClose = () => setAnchorEl(null)

  const enhancedChildren = Children.map(children, (child) =>
    isValidElement(child)
      ? cloneElement(child, {
          ...child.props,
          onClick: () => {
            child.props.onClick?.()
            handleClose()
          }
        })
      : child
  )

  return (
    <>
      <MenuButton
        onClick={handleClick}
        testId={testId}
        open={open}
        label={label}
        variant={variant}
      />

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ paper: { sx: { boxShadow: 3, borderRadius: 1, mt: 0.5 } } }}
      >
        {enhancedChildren}
      </Menu>
    </>
  )
}
